var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2270 110 16 18.595",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #868686;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "cls-1",
    d: "M26.189,959.362a2.809,2.809,0,0,0-2.588,3.905l-5.818,3.392a2.811,2.811,0,1,0,0,4l5.818,3.392a2.845,2.845,0,1,0,.2-.385l-5.736-3.338a2.791,2.791,0,0,0,0-3.338l5.736-3.338a2.809,2.809,0,1,0,2.385-4.291Zm0,.432a2.378,2.378,0,1,1-2.378,2.378A2.375,2.375,0,0,1,26.189,959.794Zm-10.378,6.487a2.378,2.378,0,1,1-2.378,2.378A2.375,2.375,0,0,1,15.811,966.281Zm10.378,6.487a2.378,2.378,0,1,1-2.378,2.378A2.375,2.375,0,0,1,26.189,972.767Z",
    transform: "translate(2257 -849.362)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share_icon.547a49e4bf59f4fb9c5cffedc6d9ba77.svg";
export { ForwardRef as ReactComponent };